import React, { useEffect, useRef } from "react";

function Step1_ProfileName({ profileName, setProfileName }) {
  const inputRef = useRef(null);

  // Focus only once when this step first mounts
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="p-4">
      <div style={{ maxWidth: "600px" }}>
        <label htmlFor="profileNameInput" className="form-label fw-bold">
          Profile name
        </label>
        <p className="text-muted small mb-2">
          Give your profile a meaningful name that reflects its policy
        </p>

        <input
          id="profileNameInput"
          ref={inputRef}
          type="text"
          className="form-control"
          value={profileName}
          onChange={(e) => setProfileName(e.target.value)}
          placeholder="e.g., 'Release readiness gate'"
        />
      </div>
    </div>
  );
}

export default Step1_ProfileName;
